<ng-container>
  <div class="l-section u-mt-sp-20 u-mt-tb-24 u-mt-pc-40">
    <div class="p-heading-area01">
      <div class="p-heading-area01__title">
        <!-- 1.1 代表者連絡先情報 -->
        <h2
          class="p-heading-area01__title c-heading-2"
          [innerHTML]="'label.representativeSelectionGroup' | staticMsg"
        ></h2>
      </div>
      <div class="p-heading-area01__sub-function">
        <!-- [2.1] 代表者連絡先情報編集 -->
        <asw-button size="xs" *ngIf="isDisplayEditContactBtn()" (click$)="clickEditRepresentiveContacts()">
          <span class="c-btn-primary__text" [innerHTML]="'label.edit' | staticMsg"></span>
        </asw-button>
      </div>
    </div>
    <div class="p-manage-booking">
      <div class="p-manage-booking__item">
        <dl class="c-float-list01">
          <div class="c-float-list01__item" *ngIf="isDisplayEmailData()">
            <!-- 1.3 代表者メールアドレス -->
            <dt class="c-float-list01__title" [innerHTML]="'label.eMailAddress.passengerInput' | staticMsg"></dt>
            <!-- [2.2] 代表者メールアドレス -->
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
              [innerHTML]="getEmailData()"
            ></dd>
          </div>
          <ng-container *ngIf="isShowTelPhone">
            <ng-container *ngIf="getResentativePhones().length; else emptyPhoneNumber">
              <ng-container *ngFor="let phone of getResentativePhones()">
                <div class="c-float-list01__item">
                  <!-- 1.5 代表者メールアドレス-->
                  <dt class="c-float-list01__title" [innerHTML]="'label.telNumber' | staticMsg"></dt>
                  <!-- [2.3] 代表者電話番号-->
                  <dd class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal">
                    {{ getTelNumber(phone) }}
                  </dd>
                </div>
              </ng-container>
            </ng-container>
            <!-- [2.3.2.1] PNR情報取得API応答.data.contacts.representative.phones[]が空である場合、label.hyphenを表示する。 -->
            <ng-template #emptyPhoneNumber>
              <div class="c-float-list01__item">
                <!-- [2.3] 代表者電話番号-->
                <dt class="c-float-list01__title" [innerHTML]="'label.telNumber' | staticMsg"></dt>
                <dd
                  class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal"
                  [innerHTML]="'label.hyphen' | staticMsg"
                ></dd>
              </div>
            </ng-template>
          </ng-container>
        </dl>
      </div>
    </div>
  </div>
</ng-container>
